<template>
    <v-dialog
        :value="dialog"
        @input="updateDialog"
        max-width="500px"
        :persistent="true"
        >
        <v-card class="CourseLive_question__card">
            <div class="CourseLive_question__title">
                <h2>질문하기</h2>
                <v-btn icon color="#aaaaaa" @click.stop="closeDialog"><v-icon class="mdi mdi-close"/></v-btn>
            </div>
            
            
            <div class="CourseLive_question__txt">
                <label>연자</label>
                <div class="CourseLive_question__lecturer"> 
                    <v-card class="select" outlined @click="selectbox">
                        <span v-if="Notselected" class="lecturer-not">
                            {{ Notselected }}
                        </span>
                        <span v-if="selectedLecturer" class="lecturer-name">
                            {{ selectedLecturer.name }}
                        </span>
                    </v-card>
                    <div class="selectlist">
                        <ul class="listbox" id="listbox" v-show="isListboxVisible" >
                            <div class="session" v-if="!isSessionSelected">
                                <div class="label"> <label>세션 선택</label></div>
                                <li v-for="(session, index) in sessions" :key="index">
                                    <v-card elevation="0" class="list" :class="{ active: activeSession === index }" @click="sessionselect(index)">
                                        <!-- {{ session }} -->
                                        <!--session 넘버와 session명으로 나눈 버전-->
                                        <p class="number">Session {{ index + 1 }}.</p>
                                        <div class="name">{{ session }}</div>
                                    </v-card>
                                </li>
                            </div>
                            <div class="lecturer" v-if="isSessionSelected">
                                <div class="label lecturer-label">
                                    <label>연자 선택</label>
                                    <v-btn
                                        class="back-to-session"
                                        text
                                        small
                                        color="primary"
                                        aria-label="세션 선택 화면으로 돌아가기"
                                        @click.stop="backToSessionList"
                                    >
                                        <v-icon small left>mdi-arrow-left</v-icon>
                                        세션 선택
                                    </v-btn>
                                </div>
                                <li v-for="lecturer in lecturers" :key="lecturer.id" @click="selectLecturer(lecturer)">
                                <v-card elevation="0" class="list">
                                    <div class="lecturer-name">{{ lecturer.name }}</div>
                                    <!-- <div class="lecturer-affiliation">({{ lecturer.affiliation }})</div> -->
                                </v-card>
                                </li>
                            </div>
                        </ul>
                    </div>
                </div>

                <label>질문 내용</label>
                <textarea v-model="content" placeholder="질문내용을 입력해주세요." />

            </div>
            <div>
                <v-btn :disabled="isButtonDisabled" @click="qnaBtn" class="CourseLive_question__btn" block elevation="0" x-large>질문하기</v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
    return {
        content: null,
        selValue: null,

        isListboxVisible: false,
        lecturerVisible: false,
        selectedLecturer: '',
        Notselected : '연자를 선택해주세요.',
        activeSession: null,
        isSessionSelected: false,
        // sessions: [
        //     // { name: 'SESSION 1' },
        //     // { name: 'SESSION 2' },
        // ],
        isButtonDisabled: true,

        lecturers: [
            // { 
            //     name: '배윤정',
            //     affiliation: '국립한국교통대 식품영양학전공'
            // },
            // { 
            //     name: '김용무',
            //     affiliation: '식품의약품안전평가원 영양기능연구과'
            // },
        ],

        };
    },
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        options: {
            type: Array,
            required: true,
        },
        sessions: {
            type: Array,
            required: true,
        },
        postMsg: {
            type: Function,
            required: true,
        },
        load: {
            type: Boolean,
            required: true,
        }
    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
    watch: {
        selectedLecturer() {
            this.checkButtonState();
        },
        activeSession() {
            this.checkButtonState();
        },
        content() {
            this.checkButtonState();
        }
    },
    created(){
        
    },  
    methods: {
        clearData(){
            this.selectedLecturer = null;
            this.selValue = null;
            this.content = null;
            this.Notselected = '연자를 선택해주세요.';
        },
        closeDialog() {
            this.dialog = false;
            this.clearData();
        },
        updateDialog(value) {
            this.$emit('input', value);
        },
        selectbox() {
            if (this.isSessionSelected) {
            this.activeSession = null;
            this.isSessionSelected = false;
        }

        this.isListboxVisible = !this.isListboxVisible;

        },
        sessionselect(index) {
            this.activeSession = index;
            this.lecturers = [];
            this.getLecturersForSession();
            this.isSessionSelected = true;
        },
        backToSessionList() {
            this.activeSession = null;
            this.isSessionSelected = false;
            this.lecturers = [];
            this.selectedLecturer = null;
            this.selValue = null;
            this.Notselected = '연자를 선택해주세요.';
            this.isListboxVisible = true;
        },
        selectLecturer(lecturer) {
            this.selectedLecturer = lecturer;
            this.Notselected = '';
            this.lecturerVisible = false;
            this.isListboxVisible = false;
            this.selValue = this.selectedLecturer.id;
            // this.sessions = [];
        },
        getLecturersForSession() {
            if (this.activeSession !== null) {
                const selectedSeminars = this.options[this.activeSession].seminars;
                this.lecturers = selectedSeminars.flatMap((seminar) => seminar.speakers);
            }
        },
        qnaBtn() {
            this.postMsg(this.selValue, this.content);
            this.clearData();
        },
        checkButtonState() {
            this.isButtonDisabled = !(this.selectedLecturer && this.activeSession != null && this.content?.trim() !== "");
        }
    },
};
</script>
